import { render } from "./PartnerDetails.vue?vue&type=template&id=1e1596ca"
import script from "./PartnerDetails.vue?vue&type=script&lang=js"
export * from "./PartnerDetails.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__